import { makeAutoObservable } from 'mobx';
import {DomainStore} from 'shared/store';
import {types, endpoints} from 'main/tools';
import {Company} from 'main/stores/company';

class GreenhouseConfigurationContainerState {
  store = new DomainStore();
  company;
  errors = {};

  deleteModalOpen = false;

  constructor() {
    makeAutoObservable(this, {
      store: false
    });
  }

  async load() {
    await this.store._compose([
      endpoints.CURRENT_COMPANY
    ]);

    this.company = new Company(
      this.store._getSingle(types.COMPANY)
    );
  }

  openDeleteModal() {
    this.deleteModalOpen = true;
  }

  cancelDeleteModal() {
    this.deleteModalOpen = false;
  }

  async generateGreenhouseKey() {
    const {errors, model} = await this.store.post(
      endpoints.INTEGRATIONS.GREENHOUSE_GENERATE_KEY,
      types.COMPANY
    );

    this.errors = errors;

    if (model) {
      this.company.update(model);
    }
  }

  async deleteGreenhouseKey() {
    const {errors, model} = await this.store.post(
      endpoints.INTEGRATIONS.GREENHOUSE_DELETE_KEY,
      types.COMPANY
    );

    this.errors = errors;

    if (model) {
      this.company.update(model);
    }

    this.deleteModalOpen = false;
  }

  get webhookUrl() {
    return `https://secure.collage.co/api/webhooks/greenhouse_hires/${this.company.id}/hire`;
  }

  get greenhouseApiKey() {
    return this.company.greenhouseApiKey;
  }
}

export default GreenhouseConfigurationContainerState;
